import { ArrowRight, Home } from 'lucide-react';
import Container from '../components/ui/Container';
import Button from '../components/ui/Button';
import { navLinks } from '../data/site';

export default function NotFound() {
  return (
    <section className="relative overflow-hidden bg-ink-950 py-28 sm:py-36">
      <div className="pointer-events-none absolute inset-0 bg-grid bg-grid-cell opacity-60" aria-hidden="true" />
      <div
        className="pointer-events-none absolute left-1/2 top-0 h-80 w-[36rem] -translate-x-1/2 rounded-full bg-brand-600/20 blur-[120px]"
        aria-hidden="true"
      />

      <Container className="relative text-center">
        <p className="font-display text-[5rem] font-bold leading-none text-brand-500/40 sm:text-[7rem]">
          404
        </p>
        <h1 className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
          This page has been recycled
        </h1>
        <p className="mx-auto mt-4 max-w-lg text-base leading-relaxed text-ink-400">
          The page you are looking for does not exist or has moved. Here is the way back.
        </p>

        <div className="mt-9 flex flex-wrap justify-center gap-3">
          <Button to="/" size="lg" variant="primary">
            <Home className="h-4 w-4" />
            Back to home
          </Button>
          <Button to="/request-pickup" size="lg" variant="onDark">
            Request a pickup
            <ArrowRight className="h-4 w-4" />
          </Button>
        </div>

        <nav aria-label="Site sections" className="mt-12 flex flex-wrap justify-center gap-x-6 gap-y-3">
          {navLinks.map((link) => (
            <a
              key={link.to}
              href={link.to}
              className="text-sm text-ink-500 transition hover:text-brand-300"
            >
              {link.label}
            </a>
          ))}
        </nav>
      </Container>
    </section>
  );
}
